/* eslint-disable import/no-dynamic-require */
import * as path from 'path';

function getMainPath(packageName: string) {
    try {
        return path.resolve(
            path.dirname(require.resolve(`${packageName}/package.json`)),
            require(`${packageName}/package.json`).main || '',
        );
    } catch (err) {
        // If the package.json declares a export property which doesn't export the package file itself, this will attempt to fallback to the the exported "."
        if (err.code === 'ERR_PACKAGE_PATH_NOT_EXPORTED') {
            return require.resolve(packageName);
        }
        throw err;
    }
}

/** Require with statCache issue workaround */
export function requireWithFallback(packageName: string) {
    // Workaround for https://github.com/nodejs/node/issues/31803 statCache
    const mainPath = getMainPath(packageName);

    return require(mainPath);
}
